import { jsx } from "react/jsx-runtime";
import { cva } from "../../../node_modules/class-variance-authority/dist/index.js";
import { forwardRef } from "react";
import { twMerge } from "../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
const helpTextVariants = cva(["inline-flex text-xs mt-1 empty:hidden"], {
  variants: {
    variant: {
      default: ["text-grayscale-500"],
      error: ["text-danger"],
      success: ["text-success"],
      warning: ["text-warning"]
    }
  },
  defaultVariants: {
    variant: "default"
  }
});
const HelpText = forwardRef((props, ref) => {
  const { children, variant, className, ...rest } = props;
  return /* @__PURE__ */ jsx("div", { ...rest, ref, className: twMerge(helpTextVariants({ variant, className })), children });
});
export {
  HelpText as default
};
//# sourceMappingURL=HelpText.js.map
